import {toast, ToastCard} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import type {FC} from 'react';

export type PayoutInstructionActionVariant = 'cancelSuccess' | 'cancelError';

type Props = {
  toastId: string | number;
  variant: PayoutInstructionActionVariant;
};

export const PayoutInstructionActionToast: FC<Props> = ({toastId, variant}) => {
  const {t} = useTranslation('trustAccounts');
  const isError = variant === 'cancelError';
  const outcome = isError ? 'error' : 'success';

  return (
    <ToastCard
      iconName={isError ? 'sollapay:close' : 'sollapay:check'}
      title={t(`view.payouts.cancel.${outcome}.title`)}
      description={t(`view.payouts.cancel.${outcome}.description`)}
      onClose={() => toast.dismiss(toastId)}
      closeLabel={t('view.payouts.cancel.toastClose')}
    />
  );
};

export function showPayoutInstructionActionToast(variant: PayoutInstructionActionVariant): void {
  toast.custom(id => <PayoutInstructionActionToast toastId={id} variant={variant} />, {
    duration: 10_000
  });
}
